import styled from "styled-components";
import { Text } from "../Text";

export const StepTitle = styled(Text)`
    font-family: "FS Emeric";
    font-weight: 600;
    font-size: 18px;
    color: var(--greenColor);
`;